(function($, undefined) {
  'use strict';
  var winWidth;
  var winHeight;
  var items;

  var autoScreenHeight = function() {
    items.each(function() {
      const t = $(this);

      const attr =
        t.data('autoScreenAttr') === undefined ? 'min-height' : t.attr('data-auto-screen-attr');
      const offset = () => {
        if (t.data('autoScreenOffset') !== undefined) {
          return t
            .data('autoScreenOffset')
            .replace(/\s+/g, '')
            .split(',');
        }
        return 0;
      };
      var factor = t.data('autoScreenFactor') !== undefined ? t.data('autoScreenFactor') : 1;
      var offsetHeight = 0;

      $.each(offset(), function(i) {
        var t = $(offset()[i]);
        offsetHeight += t.outerHeight();
      });

      var newHeight = winHeight * factor - offsetHeight;
      //console.log(`newHeight=${newHeight} winHeight=${winHeight} offsetHeight=${offsetHeight} factor=${factor}`); //Debugger

      t.css(attr, newHeight);
    });
  };

  var init = function() {
    winWidth = window.innerWidth;
    winHeight = window.innerHeight;
    items = $('.js-auto-screen-height');

    autoScreenHeight();

    $(window).resize(function() {
      winWidth = window.innerWidth;
      winHeight = window.innerHeight;

      autoScreenHeight();
    });
  };

  $(window).ready(init);
})(jQuery);
